import { asset } from "@/lib/asset";
const partnerSteps = [
    {
        id: 1,
        title: "1. Посмотрите презентацию\nпартнерской программы.",
        buttonText: "Скачать",
        alignItems: "start",
        link: asset("/docs/ka-partners.pdf"),
        icon: "ph-presentation-chart-thin.svg"
    },
    {
        id: 2,
        title: "2. Заполните форму",
        buttonText: "Перейти",
        alignItems: "end",
        link: "#partner-form",
        icon: "iconamoon-file-document-thin.svg"
    },
    {
        id: 3,
        title: "3. Мы свяжемся с вами для\nпрохождения процедуры\nавторизации.",
        buttonText: "",
        alignItems: "start",
        link: "#",
        icon: "hugeicons-calling.svg"
    }
];

const StepButton = ({ buttonText, link = "#" }) => (
    <div className="w-[108px] lg:w-[120px] h-[35px] px-5 py-2.5 bg-[#c0834d] rounded-[20px] justify-center items-center gap-2.5 flex">
        <a href={link} className="text-white text-base font-bold font-['Open Sans']">
            {buttonText}
        </a>
    </div>
);
const StepCard = ({ step }) => (
    <div className="w-full xl:w-[630px] h-auto xl:h-[152px] flex-col flex mb-[25px]">
        <div className="self-stretch justify-center lg:justify-between items-start flex flex-row-reverse lg:flex-row">
            {step.id % 2 === 1 ? (
                <>
                    <div className="w-[215px] sm-w-242px lg:w-[373px] h-full flex-wrap justify-start items-end lg:items-center gap-[40px] lg:gap-[21px] inline-flex ">
                        <div className="w-[100%] lg:w-[100%] self-stretch text-[#d3aa86] text-[15px] lg:text-2xl font-bold font-['Open Sans'] text-right lg:text-left">
                            {step.title}
                        </div>
                        <div className="w-full flex flex-col justify-end items-end lg:items-start inline-flex ">
                            {step.buttonText && <StepButton buttonText={step.buttonText} link={step.link} />}
                        </div>
                    </div>
                    <CircleIcon icon={step.icon} />
                </>
            ) : (
                <>
                    <CircleIcon icon={step.icon} />
                    <div className="w-[200px] sm-w-229px lg:w-[373px] h-full flex-wrap justify-end items-start lg:items-center gap-[40px] lg:gap-[21px] inline-flex ">
                        <div className="w-[100%] lg:w-[100%] self-stretch text-[#d3aa86] text-[15px] lg:text-2xl font-bold font-['Open Sans'] text-left lg:text-right">
                            {step.title}
                        </div>
                        <div className="w-full flex flex-col justify-start lg:items-end inline-flex">
                            <StepButton buttonText={step.buttonText} link={step.link} />
                        </div>
                    </div>
                </>
            )}
        </div>
    </div>
);

const CircleIcon = ({icon}) => (
    <div className="w-[104px] lg:w-[151.94px] h-[104px] lg:h-[151.94px] relative">
        <div className="w-[104px] lg:w-[151.94px] h-[104px] lg:h-[151.94px] left-0 lg:left-[-0.44px] absolute bg-white rounded-full shadow-[0px_2.125027656555176px_4.250055313110352px_1.062513828277588px_rgba(202,169,140,1.00)]" />

        <div className="w-[79.69px] lg:w-[115.81px] h-[79.69px] lg:h-[115.81px] left-[12px] top-[12px] lg:left-[18.06px] lg:top-[17.62px] absolute bg-[#d3aa86] rounded-full" />

        <div className="w-full lg:w-[98.81px] h-[98.81px] lg:h-[98.81px] lg:pl-[6.44px] lg:pr-[6.38px] lg:pt-[6.46px] lg:pb-[6.35px] lg:left-[26.56px] lg:top-[26.12px] absolute justify-center items-center inline-flex overflow-hidden">

            <div className="w-[57px] lg:w-[86px] h-[57px] lg:h-[86px] relative flex-col justify-center items-center flex overflow-hidden">
                <img src={asset(`/img/icons/${icon}`)} alt="icon" />
            </div>
        </div>
    </div>
);

const AboutPartnerStart = () => {
    return (
        <div className="w-full xl:w-[1422px] h-auto  flex-col lg:justify-start items-center gap-2 xl:gap-[60px] inline-flex">
            <div className="flex-col justify-start items-center flex ">
                <div className="self-stretch h-11 text-center bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text leading-normal text-[24px] lg:text-[32px] font-extrabold lg:font-bold font-['Open Sans']">
                    Хотите стать партнёром?<br />
                </div>
            </div>
            <div className="lg:px-[84px] flex-col justify-between lg:justify-start items-center gap-2 xl:gap-[120px] flex mt-[36px] xl:mt-[3px] mb-[100px]" >
                {partnerSteps.map((step) => (
                    <StepCard key={step.id} step={step} />
                ))}
            </div>
        </div>
    );
};

export default AboutPartnerStart;